/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    TitleMotorhome: {
        id: 'qnb.spm.IpidPage.TitleMotorhome',
        defaultMessage: 'Saga Motorhome Insurance'
    },
    TitleCar: {
        id: 'qnb.spm.IpidPage.TitleCar',
        defaultMessage: 'Saga Car Insurance'
    },
    TitleMotorSBA: {
        id: 'qnb.spm.IpidPage.TitleMotorSBA',
        defaultMessage: 'Saga Breakdown Assistance'
    },
    TitleMotorHomeSBA: {
        id: 'qnb.spm.IpidPage.TitleMotorHomeSBA',
        defaultMessage: 'Saga Motorhome Breakdown Assistance'
    },
    TitleSPMLegalProtection: {
        id: 'qnb.spm.IpidPage.TitleSPMLegalProtection',
        defaultMessage: '{vehicleType} Legal Protection'
    },
    SPMLegalProtectionProductTitle: {
        id: 'qnb.spm.IpidPage.SPMLegalProtectionProductTitle',
        defaultMessage: 'Legal Protection'
    },
    SPMSagaBreakdownAssistanceProductTitleEssential: {
        id: 'qnb.spm.IpidPage.SPMSagaBreakdownAssistanceProductTitleEssential',
        defaultMessage: 'Essential Breakdown Assistance'
    },
    SPMSagaBreakdownAssistanceProductTitleHomecall: {
        id: 'qnb.spm.IpidPage.SPMSagaBreakdownAssistanceProductTitleHomecall',
        defaultMessage: 'Home Call Breakdown Assistance'
    },
    SPMSagaBreakdownAssistanceProductTitleNationalrecovery: {
        id: 'qnb.spm.IpidPage.SPMSagaBreakdownAssistanceProductTitleNationalrecovery',
        defaultMessage: 'National Recovery Breakdown Assistance'
    },
    SPMSagaBreakdownAssistanceProductTitlePremier: {
        id: 'qnb.spm.IpidPage.SPMSagaBreakdownAssistanceProductTitlePremier',
        defaultMessage: 'Premier Breakdown Assistance'
    },
    SPMSagaBreakdownAssistanceProductTitleComprehensive: {
        id: 'qnb.spm.IpidPage.SPMSagaBreakdownAssistanceProductTitleComprehensive',
        defaultMessage: 'Comprehensive Breakdown Assistance'
    },
    SPMSagaBreakdownAssistanceProductTitleAssistance: {
        id: 'qnb.spm.IpidPage.SPMSagaBreakdownAssistanceProductTitleAssistance',
        defaultMessage: 'Motorhome Assistance'
    },
    SPMSagaBreakdownAssistanceProductTitleAssistanceplus: {
        id: 'qnb.spm.IpidPage.SPMSagaBreakdownAssistanceProductTitleAssistanceplus',
        defaultMessage: 'Motorhome Assistance Plus'
    },
    MotorProductTitleStandard: {
        id: 'qnb.spm.IpidPage.MotorProductTitleStandard',
        defaultMessage: 'Saga Standard {vehicleType} Insurance'
    },
    MotorProductTitlePlus: {
        id: 'qnb.spm.IpidPage.MotorProductTitlePlus',
        defaultMessage: 'Saga Plus {vehicleType} Insurance'
    },
    MotorProductTitleSelect: {
        id: 'qnb.spm.IpidPage.MotorProductTitleSelect',
        defaultMessage: 'Saga Select {vehicleType} Insurance'
    },
    MotorInsuranceTypeDesc: {
        id: 'qnb.spm.IpidPage.MotorInsuranceTypeDesc',
        defaultMessage: 'This Comprehensive policy provides cover against damage to your vehicle or damage caused by your vehicle, as summarised below.'
    },
    SBAMotorInsuranceTypeDesc: {
        id: 'qnb.spm.IpidPage.SBAMotorInsuranceTypeDesc',
        defaultMessage: 'Saga Breakdown Assistance is designed to meet the demands and needs of those who are seeking assistance in the event of a vehicle breakdown.'
    },
    SBAMotorHomeInsuranceTypeDesc: {
        id: 'qnb.spm.IpidPage.SBAMotorHomeInsuranceTypeDesc',
        defaultMessage: 'Saga Motorhome Breakdown Assistance is designed to meet the demands and needs of those who are seeking assistance in the event of a Motorhome breakdown.'
    },
    SPMLegalProtectionInsuranceTypeDesc: {
        id: 'qnb.spm.IpidPage.LegalInsuranceTypeDesc',
        defaultMessage: 'If you are involved in an accident involving your car that\'s not your fault and was caused by a known insured third party, we will provide up to £100,000 towards costs for our trained claims handlers to recover uninsured losses on behalf of you, an authorised driver or a passenger.'
    },
    HowDoIPay: {
        id: 'qnb.spm.IpidPage.HowDoIPay',
        defaultMessage: 'We offer a choice of monthly or annual premiums which can be paid by Direct Debit. In addition, we offer a choice of annual premiums which can be paid by cheque, debit or credit card. Payment will be required when you take out the policy'
    },
    HowDoIPayOther: {
        id: 'qnb.spm.IpidPage.HowDoIPayOther',
        defaultMessage: 'Your optional cover will use the same payment methods that are available under your Saga {vehicle} Insurance policy.'
    },
    EndDateMessage: {
        id: 'qnb.spm.IpidPage.EndDateMessage',
        defaultMessage: 'Your optional cover starts on the same date as your Saga {vehicle} Insurance policy, or should you wish to add the optional cover mid way through your policy year then the date will be different, however all cover will expire at the same time as your {vehicle} Insurance policy.'
    },
    // What is insured
    DamageComp: {
        id: 'qnb.spm.IpidPage.DamageComp',
        defaultMessage: 'Damage to your vehicle caused by accident, malicious damage, vandalism, fire, theft & attempted theft.'
    },
    CoverAbroad: {
        id: 'qnb.spm.IpidPage.CoverAbroad',
        defaultMessage: 'Cover abroad for an unlimited period, when you or your named spouse/partner drive in the EU.'
    },
    CoverAbroadPCW: {
        id: 'qnb.spm.IpidPage.CoverAbroadPCW',
        defaultMessage: 'Cover abroad for up to 90 days, when you or your named spouse/partner drive in the EU.'
    },
    UnlimitedLiability: {
        id: 'qnb.spm.IpidPage.UnlimitedLiability',
        defaultMessage: 'Unlimited legal liability cover for injury to other people, and up to £20,000,000 for damage to other people’s property.'
    },
    LegalProtection: {
        id: 'qnb.spm.IpidPage.LegalProtection',
        defaultMessage: 'Legal Protection – Up to £100,000 of legal costs to recover uninsured losses in the event of a non-fault claim'
    },
    KeyProtection: {
        id: 'qnb.spm.IpidPage.KeyProtection',
        defaultMessage: 'Key Protection – up to £2,500 per claim for loss, theft, or accidental damage and, with us, you even get up to £250 per incident for wear and tear. You won’t have to pay an excess and your NCD won’t be affected.'
    },
    OnwardTaxiTravel: {
        id: 'qnb.spm.IpidPage.OnwardTaxiTravel',
        defaultMessage: 'Onward Taxi Travel.'
    },
    AccidentHealthcare: {
        id: 'qnb.spm.IpidPage.AccidentHealthcare',
        defaultMessage: 'Accident Healthcare - Up to £1 million for private medical treatment of injuries sustained in a road traffic accident as a driver, motorcyclist, cyclist or pedestrian.'
    },
    ProtectedNCD: {
        id: 'qnb.spm.IpidPage.ProtectedNCD',
        defaultMessage: 'Protected No Claim Discount (NCD) - allowing 2 fault claims in 3 years.'
    },
    ClaimPromise: {
        id: 'qnb.spm.IpidPage.ClaimPromise',
        defaultMessage: 'Claims promise claims won’t affect NCD whilst with us.'
    },
    UninsuredDriver: {
        id: 'qnb.spm.IpidPage.UninsuredDriver',
        defaultMessage: 'If an uninsured driver hits your vehicle, through no fault of yours, as long as you supply their vehicle registration, we\'ll refund any excess and your No Claim Discount won\'t be affected.'
    },
    GlassRepair: {
        id: 'qnb.spm.IpidPage.GlassRepair',
        defaultMessage: 'Glass repair/replacement.'
    },
    AccidentCover: {
        id: 'qnb.spm.IpidPage.AccidentCover',
        defaultMessage: '£5,000 personal accident cover.'
    },
    HotelCover: {
        id: 'qnb.spm.IpidPage.HotelCover',
        defaultMessage: '£500 hotel/get-you-home cover.'
    },
    PersonalBelongingsPCW: {
        id: 'qnb.spm.IpidPage.PersonalBelongingsPCW',
        defaultMessage: '£400 personal belongings cover.'
    },
    PersonalBelongings: {
        id: 'qnb.spm.IpidPage.PersonalBelongings',
        defaultMessage: '£1,000 personal belongings cover.'
    },
    AudioCoverPCW: {
        id: 'qnb.spm.IpidPage.AudioCoverPCW',
        defaultMessage: '£1,000 audio/visual cover for permanently fitted equipment.'
    },
    AudioCover: {
        id: 'qnb.spm.IpidPage.AudioCover',
        defaultMessage: 'Unlimited audio/visual cover for permanently fitted equipment.'
    },
    NewForOldPCW: {
        id: 'qnb.spm.IpidPage.NewForOldPCW',
        defaultMessage: 'One year ‘new for old’ cover – if your vehicle is written off, you’ve owned it from new and it’s up to a year old, we’ll replace it with a new one.'
    },
    NewForOld: {
        id: 'qnb.spm.IpidPage.NewForOld',
        defaultMessage: 'Two year ‘new for old’ – if your vehicle is written off, you’ve owned it from new and it’s up to a year old, we’ll replace it with a new one. Vehicles between 1 and 2 years have a 12,000 mile restriction.'
    },
    MedicalExpensesPCW: {
        id: 'qnb.spm.IpidPage.MedicalExpensesPCW',
        defaultMessage: '£250 medical expenses cover.'
    },
    MedicalExpenses: {
        id: 'qnb.spm.IpidPage.MedicalExpenses',
        defaultMessage: '£300 medical expenses cover.'
    },
    PersonalBelongingsMH: {
        id: 'qnb.spm.IpidPage.PersonalBelongingsMH',
        defaultMessage: '£1,500 personal belongings cover (£100 limit per item).'
    },
    SeatCover: {
        id: 'qnb.spm.IpidPage.SeatCover',
        defaultMessage: 'New for old child car seat cover.'
    },
    CampingEquipment: {
        id: 'qnb.spm.IpidPage.CampingEquipment',
        defaultMessage: '£500 for camping equipment and gas cylinders (£100 limit per item).'
    },
    AwningsMH: {
        id: 'qnb.spm.IpidPage.AwningsMH',
        defaultMessage: '£1,500 for awnings.'
    },
    AudioEquipmentMH: {
        id: 'qnb.spm.IpidPage.AudioEquipmentMH',
        defaultMessage: '£700 for TV/audio equipment not permanently fitted (£350 limit per item).'
    },
    ReplacementCar: {
        id: 'qnb.spm.IpidPage.ReplacementCar',
        defaultMessage: 'Guaranteed replacement car – following an accident anywhere in the UK, when using our approved repair network, we\'ll provide you with a replacement car while yours is being repaired, or until it is declared a total loss.'
    },
    ReplacementCarMH: {
        id: 'qnb.spm.IpidPage.ReplacementCarMH',
        defaultMessage: 'Guaranteed replacement car – following an accident anywhere in the UK when using our approved repairer network.'
    },
    DrivingOtherCars: {
        id: 'qnb.spm.IpidPage.DrivingOtherCars',
        defaultMessage: 'Driving other cars (if shown on your Certificate).'
    },
    DrivingOtherCarsMH: {
        id: 'qnb.spm.IpidPage.DrivingOtherCarsMH',
        defaultMessage: 'Driving other cars (not a motorhome) if shown on your Certificate.'
    },
    VandalismClaim: {
        id: 'qnb.spm.IpidPage.VandalismClaim',
        defaultMessage: 'Vandalism claims won\'t affect your NCD.'
    },
    AnyDriverCOver: {
        id: 'qnb.spm.IpidPage.AnyDriverCOver',
        defaultMessage: 'Emergency ‘any driver’ cover – if a medical emergency interrupts your journey, any driver can take over the driving or take your car back home.'
    },
    AnyDriverCOverMH: {
        id: 'qnb.spm.IpidPage.AnyDriverCOverMH',
        defaultMessage: 'Emergency ‘any driver’ cover – if a medical emergency interrupts your journey, any driver can take over the driving or take your vehicle back home.'
    },
    PNCDTitle: {
        id: 'qnb.spm.IpidPage.PNCDTitle',
        defaultMessage: ' Protected No Claim Discount'
    },
    PNCDWording: {
        id: 'qnb.spm.IpidPage.PNCDWording',
        defaultMessage: 'Protected NCD - allowing 2 fault claims in 3 years.'
    },
    IncreasedPATitle: {
        id: 'qnb.spm.IpidPage.IncreasedPATitle',
        defaultMessage: 'Increased Personal Accident'
    },
    IncreasedPAWording: {
        id: 'qnb.spm.IpidPage.IncreasedPAWording',
        defaultMessage: 'Up to £150,000 per person for a wider range of injuries.'
    },
    ReplacementCarTitle: {
        id: 'qnb.spm.IpidPage.ReplacementCarTitle',
        defaultMessage: 'Replacement Car for Theft/Total Loss'
    },
    ReplacementCarWording: {
        id: 'qnb.spm.IpidPage.ReplacementCarWording',
        defaultMessage: 'A replacement car if yours is stolen or written off anywhere in the UK.'
    },
    HireCarHeading: {
        id: 'qnb.spm.IpidPage.HireCarHeading',
        defaultMessage: 'Hire Car Upgrade'
    },
    HireCarWording: {
        id: 'qnb.spm.IpidPage.HireCarWording',
        defaultMessage: 'A replacement car to suit your needs.'
    },
    KeyProtectionHeading: {
        id: 'qnb.spm.IpidPage.KeyProtectionHeading',
        defaultMessage: 'Key protection'
    },
    KeyProtectionWording: {
        id: 'qnb.spm.IpidPage.KeyProtectionWording',
        defaultMessage: 'Up to £2,500 per claim for loss, theft, or accidental damage and, with us, you even get up to £250 per incident for wear and tear. You won’t have to pay an excess and your NCD won’t be affected.'
    },

    // What is not insured
    ExcessesShownPCW: {
        id: 'qnb.spm.IpidPage.ExcessesShownPCW',
        defaultMessage: 'The excesses shown in your Statement of Insurance.'
    },
    ExcessesShown: {
        id: 'qnb.spm.IpidPage.ExcessesShown',
        defaultMessage: 'The excesses shown in your Schedule.'
    },
    JoyRiding: {
        id: 'qnb.spm.IpidPage.JoyRiding',
        defaultMessage: 'Loss or damage caused by any unauthorised use or ‘joy riding’ by a member of your family unless reported to the police.'
    },
    WearAndTear: {
        id: 'qnb.spm.IpidPage.WearAndTear',
        defaultMessage: 'Wear & tear, loss of use and mechanical, electrical, electronic or software failures.'
    },
    CompTpftLocked: {
        id: 'qnb.spm.IpidPage.CompTpftLocked',
        defaultMessage: 'Theft/attempted theft if your vehicle isn\'t fully locked and secured with the keys removed.'
    },
    MisfuellingPCW: {
        id: 'qnb.spm.IpidPage.MisfuellingPCW',
        defaultMessage: 'There is no cover for misfuelling.'
    },
    AccidentHealthcareTreatment: {
        id: 'qnb.spm.IpidPage.AccidentHealthcareTreatment',
        defaultMessage: 'Accident Healthcare - treatment received in A&E or intensive care unit, or which  began more than 14 days after the insured incident, or is required more than 12 months after, or exceeds 180 days as an inpatient.'
    },
    AccidentHealthcareCosmetic: {
        id: 'qnb.spm.IpidPage.AccidentHealthcareCosmetic',
        defaultMessage: 'Accident Healthcare - Dental or cosmetic (aesthetic) treatment, or treatment arising from deliberately self inflicted injury.'
    },
    KeyProtectionNotIncludedPlus: {
        id: 'qnb.spm.IpidPage.KeyProtectionNotIncludedPlus',
        defaultMessage: 'Key Protection- costs that exceed the market value of your vehicle.'
    },
    KeyProtectionNotIncluded: {
        id: 'qnb.spm.IpidPage.KeyProtectionNotIncluded',
        defaultMessage: 'Costs that exceed the market value of your vehicle.'
    },
    // Any Restrictions
    OtherCarsRestrictions: {
        id: 'qnb.spm.IpidPage.OtherCarsRestrictions',
        defaultMessage: 'When driving other cars, you are only covered on a Third Party only basis.'
    },
    EndorsementsRestrictionsPCW: {
        id: 'qnb.spm.IpidPage.EndorsementsRestrictionsPCW',
        defaultMessage: 'Any endorsements shown on your Statement of Insurance.'
    },
    EndorsementsRestrictions: {
        id: 'qnb.spm.IpidPage.EndorsementsRestrictions',
        defaultMessage: 'Any endorsements shown on your Schedule.'
    },
    AbroadCoverRestrictions: {
        id: 'qnb.spm.IpidPage.AbroadCoverRestrictions',
        defaultMessage: 'Use abroad cover does not extend to named drivers unless accompanied by you or your named spouse/partner.'
    },
    AdditionalDriverBusiness: {
        id: 'qnb.spm.IpidPage.AdditionalDriverBusiness',
        defaultMessage: 'Additional drivers (other than your spouse/partner) can\'t use the car for commuting or business purposes (unless in connection with you or your spouse/partner\'s own businesses).'
    },
    AdditionalDriverPersonalBusiness: {
        id: 'qnb.spm.IpidPage.AdditionalDriverPersonalBusiness',
        defaultMessage: 'Additional drivers (other than your spouse/partner) can\'t use the car for commuting or business use.'
    },
    AdditionalDriverSdpCommuting: {
        id: 'qnb.spm.IpidPage.AdditionalDriverSdpCommuting',
        defaultMessage: 'Additional drivers (other than your spouse/partner) can\'t use the car for commuting.'
    },
    CommutingBusinessRestrictionsMH: {
        id: 'qnb.spm.IpidPage.CommutingBusinessRestrictionsMH',
        defaultMessage: 'Your motorhome is covered for social, domestic and pleasure use only, excluding commuting or business purposes.'
    },
    CompVandalRestrictions: {
        id: 'qnb.spm.IpidPage.CompVandalRestrictions',
        defaultMessage: 'For a vandalism claim, you must provide us with a Police crime reference number.'
    },
    CompVandalRestrictionsPCW: {
        id: 'qnb.spm.IpidPage.CompVandalRestrictionsPCW',
        defaultMessage: 'Vandalism claims will affect NCD.'
    },
    CompUninsuredRestrictions: {
        id: 'qnb.spm.IpidPage.CompUninsuredRestrictions',
        defaultMessage: 'Uninsured driver promise doesn\'t apply to uninsured drivers of your own vehicle. You must provide us with the other vehicle\'s registration number.'
    },
    CompSunroofsRestrictions: {
        id: 'qnb.spm.IpidPage.CompSunroofsRestrictions',
        defaultMessage: 'Panoramic glass sunroofs are covered as standard ‘Loss or damage’ claims, and as such, are subject to the Accidental damage policy excess.'
    },
    EmergencyRestrictions: {
        id: 'qnb.spm.IpidPage.EmergencyRestrictions',
        defaultMessage: 'With Emergency ‘any driver’ cover, if you’re not in the vehicle  it can only be driven straight to your home.'
    },
    RestrictionsAccidentHealthcare: {
        id: 'qnb.spm.IpidPage.RestrictionsAccidentHealthcare',
        defaultMessage: 'Accident Healthcare - applicable to the policyholder (and spouse/partner if applicable).'
    },
    RestrictionsLegalProtection: {
        id: 'qnb.spm.IpidPage.RestrictionsLegalProtection',
        defaultMessage: 'Legal Protection – we will not provide assistance if there is less than a 51% chance of succeeding with the claim.'
    },
    KeyProtectionRestrictionPlus: {
        id: 'qnb.spm.IpidPage.KeyProtectionRestrictionPlus',
        defaultMessage: 'Key Protection- claims notified more than 60 days after the insured incident.'
    },
    KeyProtectionRestriction: {
        id: 'qnb.spm.IpidPage.KeyProtectionRestriction',
        defaultMessage: 'Claims notified more than 60 days after the insured incident.'
    },
    LegalProtectionRestriction: {
        id: 'qnb.spm.IpidPage.LegalProtectionRestriction',
        defaultMessage: 'Legal Protection - you are covered for Uninsured Loss Recovery in United Kingdom, Isle of Man, Channel Islands and Gibraltar. Member countries of the EU and Andorra, Bosnia and Herzegovina, Iceland, Liechtenstein, Monaco, Montenegro, Norway, Serbia, Switzerland, Madeira and San Marino.<br/>For all other sections of cover: The United Kingdom, Gibraltar, the Isle of Man, and the Channel Islands.'
    },

    // Covered
    UkCovered: {
        id: 'qnb.spm.IpidPage.UkCovered',
        defaultMessage: 'United Kingdom, Isle of Man, Channel Islands and Gibraltar.'
    },
    EuCovered: {
        id: 'qnb.spm.IpidPage.EuCovered',
        defaultMessage: 'Member countries of the EU and Andorra, Bosnia and Herzegovina, Iceland, Liechtenstein, Madeira, Monaco, Montenegro, Norway, San Marino, Serbia and Switzerland.'
    },

    // Obligations
    TellUsObligations: {
        id: 'qnb.spm.IpidPage.TellUsObligations',
        defaultMessage: 'To answer all questions honestly and fully and tell us as quickly as possible about any changes; eg to your address, vehicle or driver details.'
    },
    ComplyObligations: {
        id: 'qnb.spm.IpidPage.ComplyObligations',
        defaultMessage: 'To comply with all laws/codes to keep the insured vehicle safe and fit to drive and give us as quickly as possible, full details of any incident which could lead to a claim.'
    },
    // Legal
    // What is insured
    legalInsuredDisputeTitle: {
        id: 'qnb.spm.IpidPage.legalInsuredDisputeTitle',
        defaultMessage: 'Up to £100,000 of legal costs for trained claims handlers to recover uninsured losses from the driver responsible, on behalf of you, an authorised driver or a passenger. Cover is provided for expenses such as:'
    },
    LegalInsuredCompensation: {
        id: 'qnb.spm.IpidPage.LegalInsuredCompensation',
        defaultMessage: 'Compensation for personal injury and medical costs'
    },
    LegalInsuredAlternative: {
        id: 'qnb.spm.IpidPage.LegalInsuredAlternative',
        defaultMessage: 'Alternative transport expenses'
    },
    LegalInsuredLossOfEarnings: {
        id: 'qnb.spm.IpidPage.LegalInsuredLossOfEarnings',
        defaultMessage: 'Loss of earnings'
    },
    LegalInsuredDispute: {
        id: 'qnb.spm.IpidPage.legalInsuredDispute',
        defaultMessage: 'Essential out of pocket expenses'
    },
    legalInsuredDisputeTitleList: {
        id: 'qnb.spm.IpidPage.legalInsuredDisputeTitleList',
        defaultMessage: 'Up to £100,000 of legal costs for trained claims handlers to recover uninsured losses from the driver responsible, on behalf of you, an authorised driver or a passenger. Cover is provided for expenses such as:<ul><li>Compensation for personal injury and medical costs</li><li>Alternative transport expenses</li><li>Loss of earnings</li><li>Essential out of pocket expenses</li></ul>'
    },
    legalInsuredEssential: {
        id: 'qnb.spm.IpidPage.legalInsuredEssential',
        defaultMessage: 'Unlimited access to motoring legal advice – our legal helpline is confidential, free and available 24 hours a day, 365 days a year.'
    },
    LegalInsuredPurchase: {
        id: 'qnb.spm.IpidPage.LegalInsuredPurchase',
        defaultMessage: 'Up to 100% of the purchase price of your vehicle, or the cost of servicing/repair, if you need to take legal action, or defend an appeal, against a motor trader in a dispute involving the purchase, servicing, or repair of your {vehicle}.'
    },
    LegalInsuredTwoHour: {
        id: 'qnb.spm.IpidPage.LegalInsuredTwoHour',
        defaultMessage: 'Four hours driver confidence coaching to help you get back in the driving seat if you have lost confidence in driving.'
    },
    LegalInsuredLegalCosts: {
        id: 'qnb.spm.IpidPage.LegalInsuredLegalCosts',
        defaultMessage: 'Up to £10,000 of legal costs to defend you and/or an authorised driver from prosecution involving your car, and/or from the risk of loss of licence arising from the use of your {vehicle}.'
    },
    LegalInsuredEssentialCloned: {
        id: 'qnb.spm.IpidPage.LegalInsuredEssentialCloned',
        defaultMessage: 'Up to £100,000 of legal costs in respect of any legal claim arising from your vehicle being cloned.'
    },
    LegalInsuredEssentialClamping: {
        id: 'qnb.spm.IpidPage.LegalInsuredEssentialClamping',
        defaultMessage: 'Up to £10,000 of legal costs in respect of any legal claim to pursue the recovery of illegal clamping or towing fees relating to your vehicle.'
    },
    // whatIsNotInsured
    LegalNotInsuredOccured: {
        id: 'qnb.spm.IpidPage.LegalNotInsuredOccured',
        defaultMessage: 'An event that occurred before this policy started, or outside of the territory, unless it is a Motor Trade Cover claim relating to the purchase of your {vehicle}, which you did not become aware of until after this policy started.'
    },
    LegalNotInsuredAccident: {
        id: 'qnb.spm.IpidPage.LegalNotInsuredAccident',
        defaultMessage: 'An accident the policyholder, authorised driver or passenger is legally liable for.'
    },
    LegalNotInsuredDispute: {
        id: 'qnb.spm.IpidPage.LegalNotInsuredDispute',
        defaultMessage: 'A dispute between the insured person and the Insurer or Saga Group Limited.'
    },
    LegalNotInsuredProsecution: {
        id: 'qnb.spm.IpidPage.LegalNotInsuredProsecution',
        defaultMessage: 'Prosecution of you and/or an authorised driver if their driving licence has 6 or more penalty points within the 3 years immediately prior to the offence'
    },
    LegalNotInsuredTrade: {
        id: 'qnb.spm.IpidPage.LegalNotInsuredTrade',
        defaultMessage: 'Motor Trade Cover legal costs you incur before we\'ve accepted your claim'
    },
    LegalNotInsuredLegal: {
        id: 'qnb.spm.IpidPage.LegalNotInsuredLegal',
        defaultMessage: 'We won\'t pay any expenses incurred as a result of the insured person failing to provide instructions/information to the appointed legal representative.'
    },
    LegalNotInsuredLoses: {
        id: 'qnb.spm.IpidPage.LegalNotInsuredLoses',
        defaultMessage: 'Unlimited access to motoring legal advice – our legal helpline is confidential, free and available 24 hours a day, 365 days a year.'
    },
    CoverForAnyLoss: {
        id: 'qnb.spm.IpidPage.CoverForAnyLoss',
        defaultMessage: 'We will not provide cover for any losses (other than legal costs) incurred by you because of your vehicle being cloned.'
    },
    LegalNotInsuredClamping: {
        id: 'qnb.spm.IpidPage.LegalNotInsuredClamping',
        defaultMessage: 'We will not provide cover where the clamping or towing of your vehicle has been carried out with lawful authority.'
    },
    // Restrictions
    LegalRestrictionsAssistance: {
        id: 'qnb.spm.IpidPage.LegalRestrictionsAssistance',
        defaultMessage: 'We will not provide assistance if there is less than a 51% chance of succeeding with the claim and if it would be unreasonable to advise any private paying client in the same circumstances to pursue the claim.'
    },
    LegalRestrictionsDefence: {
        id: 'qnb.spm.IpidPage.LegalRestrictionsDefence',
        defaultMessage: 'The defence of the insured person in a civil claim is not covered under this policy, but cover may be provided under your standard Saga {vehicle} Insurance policy.'
    },
    LegalRestrictionsTrade: {
        id: 'qnb.spm.IpidPage.LegalRestrictionsTrade',
        defaultMessage: 'Motor Trade Cover claims must be reported to us within 180 days of the date of the dispute unless reasonable prospects exist, and Driver Confidence claims must be reported to us within 90 days of the accident.'
    },
    LegalRestrictionsLegalRep: {
        id: 'qnb.spm.IpidPage.LegalRestrictionsLegalRep',
        defaultMessage: 'We will not pay legal costs in excess of the amount of damages that you are able to claim from your opponent.'
    },
    // covered
    LegalCoveredForUninsured: {
        id: 'qnb.spm.IpidPage.LegalCoveredForUninsured',
        defaultMessage: 'For Uninsured Loss Recovery: United Kingdom, Isle of Man, Channel Islands and Gibraltar. Member countries of the EU and Andorra, Bosnia and Herzegovina, Iceland, Liechtenstein, Monaco, Montenegro, Norway, Serbia, Switzerland, Madeira and San Marino'
    },
    LegalCoveredForOther: {
        id: 'qnb.spm.IpidPage.LegalCoveredForOther',
        defaultMessage: 'For all other sections of cover: The United Kingdom, Gibraltar, the Isle of Man and the Channel Islands.'
    },
    // Obligations
    LegalObligationsEnsure: {
        id: 'qnb.spm.IpidPage.LegalObligationsEnsure',
        defaultMessage: 'To ensure that you have taken care to provide us with correct information and answer all questions honestly, fully and to the best of your knowledge.'
    },
    LegalObligationsQuickly: {
        id: 'qnb.spm.IpidPage.LegalObligationsQuickly',
        defaultMessage: 'To tell us as quickly as possible about any changes and advise us as quickly as possible if there is no longer reasonable prospects and no further legal costs should be incurred without our consent.'
    },
    LgalObligationsComply: {
        id: 'qnb.spm.IpidPage.LgalObligationsComply',
        defaultMessage: 'To comply with all laws and codes to keep the insured vehicle safe and fit to drive'
    },
    LegalObligationsIncident: {
        id: 'qnb.spm.IpidPage.LegalObligationsIncident',
        defaultMessage: 'To give us as quickly as possible, full details of any incident which could lead to a claim or legal proceedings.'
    },
    legalObligationsClaim: {
        id: 'qnb.spm.IpidPage.legalObligationsClaim',
        defaultMessage: 'To provide us with any information regarding proceedings as quickly as possible, and to act in accordance with appointed representative’s advice, and in a manner which does not prejudice the settlement of any claim.'
    },
    legalObligationsProceedings: {
        id: 'qnb.spm.IpidPage.legalObligationsProceedings',
        defaultMessage: 'Unlimited access to motoring legal advice – our legal helpline is confidential, free and available 24 hours a day, 365 days a year.'
    },
    // SBA
    // whatIsInsured
    SBAInsuredEsRoadside: {
        id: 'qnb.spm.IpidPage.SBAInsuredEsRoadside',
        defaultMessage: 'Roadside repair.'
    },
    SBAInsuredHCImb: {
        id: 'qnb.spm.IpidPage.SBAInsuredHCImb',
        defaultMessage: 'Cover for immobilisation of the insured vehicle as a result of breakdown, road accident, vandalism, accidental damage, fire, flat tyre, lack of fuel, flat battery, loss or breakage of vehicle keys, within the United Kingdom.'
    },
    SBAInsuredHomeAssist: {
        id: 'qnb.spm.IpidPage.SBAInsuredHomeAssist',
        defaultMessage: 'Assistance at your home'
    },
    SBAInsuredHcRec: {
        id: 'qnb.spm.IpidPage.SBAInsuredHcRec',
        defaultMessage: 'Recovery of your car, caravan/trailer and up to six people to a garage, or a place of your choice within ten miles of the breakdown.'
    },
    SBAInsuredHCRecover: {
        id: 'qnb.spm.IpidPage.SBAInsuredHCRecover',
        defaultMessage: 'If we recover the insured vehicle to a garage, we will reimburse you for taxi costs to continue the journey to a single destination within 20 miles.'
    },
    SBAInsuredHCPunc: {
        id: 'qnb.spm.IpidPage.SBAInsuredHCPunc',
        defaultMessage: 'Puncture repair on your car and caravan/trailer if you are towing.'
    },
    SBAInsuredHCCaravan: {
        id: 'qnb.spm.IpidPage.SBAInsuredHCCaravan',
        defaultMessage: 'Caravan/trailers have the same cover as the insured vehicle when being towed by it.'
    },
    SBAInsuredEsRec: {
        id: 'qnb.spm.IpidPage.SBAInsuredEsRec',
        defaultMessage: 'Recovery of your car, caravan/trailer and up to six people to a garage, or a place of your choice within ten miles of the breakdown.'
    },
    SBAInsuredCcRec: {
        id: 'qnb.spm.IpidPage.SBAInsuredCcRec',
        defaultMessage: 'Recovery of your car, caravan/trailer and all insured persons to a garage, or place of your choice anywhere in the UK.'
    },
    SBAInsuredCompCare: {
        id: 'qnb.spm.IpidPage.SBAInsuredCompCare',
        defaultMessage: 'Driver care - hire car, alternative transport or overnight accommodation if you cant use your car, or a chauffeur if there is an accidental injury, sudden illness or death which means no one can drive the insured vehicle.'
    },
    SBAInsuredPremierEuro: {
        id: 'qnb.spm.IpidPage.SBAInsuredPremierEuro',
        defaultMessage: 'European cover – for repair and recovery.'
    },
    SBAInsuredPremierHoliday: {
        id: 'qnb.spm.IpidPage.SBAInsuredPremierHoliday',
        defaultMessage: 'Holiday departure cover – if you are going on holiday, cover to get you to your departure point and recover your car and/or a hire car to continue your trip for up to 14 days if the insured vehicle breaks down within 24 hours of your planned departure date and cannot be repaired.'
    },
    SBARecoveryMH: {
        id: 'qnb.spm.IpidPage.SBARecoveryMH',
        defaultMessage: 'Recovery of your motorhome, caravan/trailer and all insured persons to a place of your choice anywhere in the UK.'
    },
    SBACoveredMH: {
        id: 'qnb.spm.IpidPage.SBACoveredMH',
        defaultMessage: 'Your motorhome is covered whoever is driving, provided they have a full licence and are driving with your permission.'
    },
    SBAPuncMH: {
        id: 'qnb.spm.IpidPage.SBAPuncMH',
        defaultMessage: 'Puncture repair on your motorhome and caravan/trailer if you are towing.'
    },
    // whatIsInsured

    SBANotInsuredPriorToPurchase: {
        id: 'qnb.spm.IpidPage.SBANotInsuredPriorToPurchase',
        defaultMessage: 'Any insured incident which has occurred prior to purchase.'
    },
    SBANotInsuredFuel: {
        id: 'qnb.spm.IpidPage.SBANotInsuredFuel',
        defaultMessage: 'The cost of fuel and/or all spare parts.'
    },
    SBANotInsuredWheel: {
        id: 'qnb.spm.IpidPage.SBANotInsuredWheel',
        defaultMessage: 'The cost of getting a spare wheel or for roadside repairs if you cannot provide a suitable spare wheel.'
    },
    SBANotInsuredLabour: {
        id: 'qnb.spm.IpidPage.SBANotInsuredLabour',
        defaultMessage: 'Any costs whatsoever in respect of labour, parts, materials, storage, safekeeping or relocation of the insured vehicle once it has been transported to a garage or repairer.'
    },
    SBANotInsuredHireReward: {
        id: 'qnb.spm.IpidPage.SBANotInsuredHireReward',
        defaultMessage: 'Vehicles used for hire and reward or courier services.'
    },
    // Restrictions
    SBARestrictionsHcLevels: {
        id: 'qnb.spm.IpidPage.SBARestrictionsHcLevels',
        defaultMessage: 'Cover is available for a car, three wheeler or van up to 3,500kg when loaded that has been privately registered in the United Kingdom. None of these must be more than 7m (23") in length, 3m (9\'10") in height and 2.25m (8\'4") in width.'
    },
    SBARestrictionsHcCaravan: {
        id: 'qnb.spm.IpidPage.SBARestrictionsHcCaravan',
        defaultMessage: 'Caravan/trailers must conform to The Motor Vehicles (Construction and Use) Regulations 1986 and fit to a standard 50mm towball.'
    },
    SBARestrictionsEsLevels: {
        id: 'qnb.spm.IpidPage.SBARestrictionsEsLevels',
        defaultMessage: 'Channel Islands'
    },
    SBARestrictionsEsApplies: {
        id: 'qnb.spm.IpidPage.SBARestrictionsEsApplies',
        defaultMessage: 'Cover applies anywhere in the UK as long as your vehicle is at least a ¼ of a mile from your home.'
    },
    SBARestrictionsPremFive: {
        id: 'qnb.spm.IpidPage.SBARestrictionsPremFive',
        defaultMessage: 'European cover - we will provide assistance up to five times in any 12 month period of cover.'
    },
    // covered
    SBACoveredUk: {
        id: 'qnb.spm.IpidPage.SBACoveredUk',
        defaultMessage: 'United Kingdom'
    },
    SBACoveredIom: {
        id: 'qnb.spm.IpidPage.SBACoveredIom',
        defaultMessage: 'Isle of Man'
    },
    SBACoveredChannel: {
        id: 'qnb.spm.IpidPage.SBACoveredChannel',
        defaultMessage: 'Channel Islands'
    },
    SBACoveredPrem: {
        id: 'qnb.spm.IpidPage.SBACoveredPrem',
        defaultMessage: 'Albania, Andorra, Armenia, Austria, Azerbaijan, Balearics, Belarus, Belgium, Bosnia Herzegovina, Bulgaria, Canary Isles, Corsica, Croatia, Cyprus, Czech Republic, Denmark, Estonia, Finland, France, Georgia, Germany, Gibraltar, Greece, Hungary, Iceland, Italy, Kosovo, Latvia, Liechtenstein, Lithuania, Luxembourg, Macedonia, Malta, Moldova, Monaco, Montenegro, the Netherlands, Norway, Poland, Portugal, Romania, Russian mainland (west of Urals), San Marino, Sardinia, Serbia, Sicily, Slovak Republic, Slovenia, Spain, Sweden, Switzerland, Turkey in Europe plus Üsküdar, the Republic of Ireland, Ukraine and Vatican City.'
    },
    // obligations

    SBAObligations: {
        id: 'qnb.spm.IpidPage.SBAObligations',
        defaultMessage: 'To ensure that you have taken care to provide us with correct information and answer all questions honestly, fully and to the best of your knowledge.'
    },
    SBAObligationsQuick: {
        id: 'qnb.spm.IpidPage.SBAObligationsQuick',
        defaultMessage: 'To tell us as quickly as possible about any changes, for example: to your address; or the insured vehicle.'
    },
    SBAObligationsLaws: {
        id: 'qnb.spm.IpidPage.SBAObligationsLaws',
        defaultMessage: 'To comply with all laws and codes to keep the insured vehicle safe and fit to drive.'
    },
});
